import {burger} from "./parts/burger.js";
import {headerFixed} from "./parts/header-fixed.js";

export const header = ()=> {

    gsap.to('.header__inner', {
        scrollTrigger: {
            trigger: '.header__inner',
            start: 'top 85%',
            end: 'bottom 10%',
        },
        y: 0,
        opacity: 1,
        duration: .5,
    })

    burger();

    headerFixed();
}